import React, { useState, useEffect,useRef,  } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Card,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Snackbar,
  Alert,
  List,
  RadioGroup,
  FormControlLabel,
  ListItem,
  ListItemText,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
  Chip,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  grid2Classes
} from "@mui/material";
import { PhotoCamera, AttachFile, Delete, Add, FilterSharp } from "@mui/icons-material";
import ApiService from '../../API/Requesthandler';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/prime.css"
import dayjs from "dayjs";
const steps = ["Select Sender","Create Message", "Select Receivers","Message Type","Send Message"];




// Pre-defined message templates
const predefinedTemplates = [
  { id: 1, text: "Hello, how are you?" },
  { id: 2, text: "Are we still on for tomorrow?" },
  { id: 3, text: "Don't forget to bring the documents." },
];

function MessageCreation() {
  const navigate = useNavigate()
  const [activeStep, setActiveStep] = useState(0);
  const [messageText, setMessageText] = useState("");
  const [messageHeader,setMessageHeader] = useState("");
  const [photos, setPhotos] = useState([]);
  const [files, setFiles] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [value, setValue] = useState(new Date());
  const inputRef = useRef(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [selectedContact, setSelectedContact] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [matchedMessages, setMatchedMessages] = useState([]);
  const [chatsdata, setChatsData] = useState([]);
  const [mode, setMode] = useState("write"); // 'write' or 'search'
  const [templates, setTemplates] = useState(predefinedTemplates);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [newTemplateText, setNewTemplateText] = useState("");
  const [senderNumbers, setSenderNumbers] = useState([]);
  const [selectedSender, setSelectedSender] = useState(null);
  const [disableDayFilter, setDisableDayFilter] = useState(false);
    const [monthDateFilter,setMonthDateFilter] = useState(false);
  const [searchContactText, setSearchContactText] = useState("");
  const [selectedDates,setSelectedDates] = useState("");
  const [messageType, setMessageType] = useState(""); 
  const now = new Date();
  const time = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
  });
  const [schedule, setSchedule] = useState({
    start: new Date().toISOString().split('T')[0],
    end: '2026-12-31',
    repeat: { value: 1, unit: 'week' },
    timeSlot: new Date(),
    dayFilter: [],
    monthdate: "",
    daterange: []
  });

  
  
    const handleMessageTypeChange = (event) => {
      setMessageType(event.target.value);
    };

    // Filter contacts based on search text
    const filteredContacts = contacts.filter((contact) =>
      contact.name.toLowerCase().includes(searchContactText.toLowerCase())
    );
    
    const handleDateChange = (dates) => {
      if (!Array.isArray(dates)) return; // Ensure dates is an array
      const formattedDates = dates.map(formatDate); // Convert Date objects to strings
      // console.log(formattedDates)
      setValue(dates); // Update state with formatted strings
      
    };

    const formatDate = (date) => {
      if (!(date instanceof Date)) return ""; // Ensure it's a valid Date object
      const day = String(date.getDate()).padStart(2, "0"); // 2-digit day
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 2-digit month
      const year = date.getFullYear();
      return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
    };
  const handleTimeChange = (time) => {
    setSchedule({ ...schedule, timeSlot: time });
  };

  // Handle repeat interval change
  const handleRepeatChange = (field, value) => {
    const updatedRepeat = { ...schedule.repeat, [field]: value };
    setSchedule({ ...schedule, repeat: updatedRepeat });

    // Disable day filter if interval is not days, weeks, or months
    if (field === 'unit') {
      setDisableDayFilter(!['days', 'weeks', 'months'].includes(value));
    }

    if (field == "unit"){
      setMonthDateFilter(!['months'].includes(value));
      
    }
    
  };

  // Handle day filter change
  const handleDayChange = (e) => {
    setSchedule({ ...schedule, dayFilter: e.target.value });
  };


  const  handlePostpondSend = () => {
    
    // schedule.type = "instant"
    const dateVals = document.querySelector("#dp-multiple").value
    if (dateVals.includes(',')){
      var sp = dateVals.split(',')
      schedule.daterange = sp
      schedule.start = sp[0]
      schedule.end = sp[sp.length - 1]
    }else if (dateVals.length > 0){
      schedule.daterange = [dateVals]
      schedule.start = dateVals
      schedule.end = dateVals
    }

    
      // console.log(schedule)
    
    if (!messageText.trim() || selectedContacts.length === 0 || !selectedSender) {
      setSnackbar({ open: true, message: "Fill message, contacts, scheduled time and select sender.", severity: "error" });
      return;
    }

    // console.log("Sending from:", selectedSender);
    // console.log("To:", selectedContacts);
    // console.log("Message:", messageText);
    // console.log("file:"+files)
    // console.log("photos:"+photos)
    setSnackbar({ open: true, message: "Message sent instantly.", severity: "success" });
    setSelectedContacts([]);
    setSelectedSender(null);


    const formData = new FormData();

    for (let i = 0; i < photos.length; i++) {
      formData.append('photos', photos[i]); // Key: "photos"
    }

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]); // Key: "files"
    }
    formData.append('user_id',JSON.parse(localStorage.getItem("user-data"))['id'])
    formData.append('message', messageText);
    formData.append('file_type',files.length > 0 ? "file" : photos.length > 0 ? "photo" : "")
    formData.append('sendfrom', selectedSender);
    formData.append('sentto', JSON.stringify(selectedContacts));
    formData.append("type","POSTPOND");
    formData.append("filter",JSON.stringify(schedule))
    formData.append('message_header',messageHeader)



    ApiService.post('/api/chat/send',formData)
    .then(res =>{
      // console.log(res)
      setActiveStep(0)
    }).catch(err =>{
      console.log(err)
    })

    
  }

 
  // Logical schedule handler – add your scheduling logic here
  const handleScheduleSend = () => {
    // schedule.type = "instant"
    // var arr = []
    // value.foreach((el)=>{
    //   arr.append(el)
    // })
    // schedule.daterange = arr
    
    if (!messageText.trim() || selectedContacts.length === 0 || !selectedSender) {
      setSnackbar({ open: true, message: "Fill message, contacts, scheduled time and select sender.", severity: "error" });
      return;
    }

    schedule.daterange = []

    // console.log("Sending from:", selectedSender);
    console.log("To:", selectedContacts);
    // console.log("Message:", messageText);
    // console.log("file:"+files)
    // console.log("photos:"+photos)
    setSnackbar({ open: true, message: "Message sent instantly.", severity: "success" });
    setSelectedContacts([]);
    setSelectedSender(null);


    const formData = new FormData();

    for (let i = 0; i < photos.length; i++) {
      formData.append('photos', photos[i]); // Key: "photos"
    }

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]); // Key: "files"
    }
    formData.append('user_id',JSON.parse(localStorage.getItem("user-data"))['id'])
    formData.append('message', messageText);
    formData.append('file_type',files.length > 0 ? "file" : photos.length > 0 ? "photo" : "")
    formData.append('sendfrom', selectedSender);
    formData.append('sentto', JSON.stringify(selectedContacts));
    formData.append("type","SCHEDULE");
    formData.append("filter",JSON.stringify(schedule))
    formData.append('message_header',messageHeader)



    ApiService.post('/api/chat/send',formData)
    .then(res =>{
      // console.log(res)
      setActiveStep(0)
    }).catch(err =>{
      console.log(err)
    })
    
  };
    


  const getSessions = ()=>{
      ApiService.post("/api/phone/sessions",{"user_id":JSON.parse(localStorage.getItem("user-data"))['id']})
      .then(response =>{
        const formattedSessions = response.map((session)=>({
            id: session.id,
            phone_number:session.phone,
            status: "active",
            lastActive: new Date().toISOString(),
            user_id:session.user_id,
            session:session.session,
            default: session.default,
            username : session.username
        }));
        setSenderNumbers(formattedSessions);
      }).catch(err =>{
        console.log(err)
      })
    }



  useEffect(() => {
    getSessions()
    
  }, []);

  const getChatsData = (sender) => {
    ApiService.get("/api/chat/get/"+JSON.parse(localStorage.getItem('user-data'))['id'] + "/" + sender.phone_number)
    
      .then(res => {
        if (res.success == true) {
          localStorage.setItem("chats", JSON.stringify(res.data));
          setChatsData(res.data);
          handleFetchContacts()
        }
      }).catch(err => {
        console.log(err);
      });
  };

  const handleNext = () => {
    if (activeStep === 0 && ! selectedSender) {
      setSnackbar({ open: true, message: "Please select a sender number.", severity: "error" });
      
      
      return;
    }
    if (activeStep === 1 && (!messageText.trim() || !messageHeader.trim())) {
      setSnackbar({ open: true, message: "Please enter your message or select a message.", severity: "error" });
      
      return;
    }
    if (activeStep === 2 && selectedContacts.length === 0) {
      setSnackbar({ open: true, message: "Please select at least one contact.", severity: "error" });
      return;
    }
    if (activeStep === 3 && !messageType){
      setSnackbar({open: true,message:"Please select a message type before proceeding.",severity:"error"})
      return
    }
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleFetchContacts = () => {
    setContacts(JSON.parse(localStorage.getItem("chats")));
    setSnackbar({ open: true, message: "Contacts fetched.", severity: "info" });
  };

  const handleSelectContact = (contact) => {
    setSelectedContacts((prev) => {
      const isSelected = prev.some((c) => c.id === contact.id);
  
      if (isSelected) {
        // Remove contact object if already selected
        return prev.filter((c) => c.id !== contact.id);
      } else {
        // Add contact object if not already selected
        return [...prev, { id: contact.id, name: contact.name }];
      }
    });
  };

  const handleFetchMessages = () => {
    if (!selectedContact) {
      setSnackbar({ open: true, message: "Please select a contact to search messages.", severity: "error" });
      return;
    }
    const filteredMessages = templates.filter((msg) => msg.text.toLowerCase().includes(searchText.toLowerCase()));
    setMatchedMessages(filteredMessages);
  };

  const handleSelectMessage = (message) => {
    setMessageText(message.text);
    setMatchedMessages([]);
  };

  const handleInstantSend = () => {
    if (!messageText.trim() || selectedContacts.length === 0 || !selectedSender) {
      setSnackbar({ open: true, message: "Complete message, contact selection, and sender selection.", severity: "error" });
      return;
    }
    schedule.daterange = []
    // console.log("Sending from:", selectedSender);
    // console.log("To:", selectedContacts);
    // console.log("Message:", messageText);
    // console.log("file:"+files)
    // console.log("photos:"+photos)
    setSnackbar({ open: true, message: "Message sent instantly.", severity: "success" });
    setSelectedContacts([]);
    setSelectedSender(null);


    const formData = new FormData();

    for (let i = 0; i < photos.length; i++) {
      formData.append('photos', photos[i]); // Key: "photos"
    }

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]); // Key: "files"
    }
    formData.append('user_id',JSON.parse(localStorage.getItem("user-data"))['id'])
    formData.append('message', messageText);
    formData.append('file_type',files.length > 0 ? "file" : photos.length > 0 ? "photo" : "")
    formData.append('sendfrom', selectedSender);
    formData.append('sentto', JSON.stringify(selectedContacts));
    formData.append("type","INSTANT");
    formData.append("filter","")
    formData.append('message_header',messageHeader)

    ApiService.post('/api/chat/send',formData)
    .then(res =>{
      // console.log(res)
      setActiveStep(0)
    }).catch(err =>{
      console.log(err)
    })

  };


 

  const handleFileUpload = (event) => {
    const uploadedFiles = Array.from(event.target.files);
    setFiles((prev) => [...prev, ...uploadedFiles]);
  };

  const handlePhotoUpload = (event) => {
    const uploadedPhotos = Array.from(event.target.files);
    setPhotos((prev) => [...prev, ...uploadedPhotos]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemovePhoto = (index) => {
    setPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTemplate = () => {
    if (newTemplateText.trim()) {
      const newTemplate = { id: templates.length + 1, text: newTemplateText };
      setTemplates((prev) => [...prev, newTemplate]);
      setNewTemplateText("");
      setOpenTemplateDialog(false);
      setSnackbar({ open: true, message: "Template added successfully.", severity: "success" });
    }
  };

  const renderStep1 = () => (
    <Card sx={{ mb: 4, borderRadius: 2,  maxWidth: '80%',p: 2,mx: 'auto' }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Create a New Message
        </Typography>
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={(event, newMode) => setMode(newMode)}
          aria-label="message mode"
          sx={{ mb: 2 }}
        >
          Write Message
          {/* <ToggleButton value="write" aria-label="write message">
            Write Message
          </ToggleButton>
          <ToggleButton value="search" aria-label="search message">
            Search Message
          </ToggleButton> */}
        </ToggleButtonGroup>

        {mode === "write" ? (
          <>
          <TextField
              label="Message Title"
              value={messageHeader}
              onChange={(e) => setMessageHeader(e.target.value)}
              fullWidth
              
              rows={1}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <TextField
              label="Message Text"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              fullWidth
              multiline
              rows={7}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Button variant="outlined" component="label" disabled={files.length > 0 ? true : false} startIcon={<PhotoCamera />}>
                  Upload Photos
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    multiple
                    onChange={handlePhotoUpload}
                  />
                </Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" component="label" disabled={photos.length > 0 ? true : false} startIcon={<AttachFile />}>
                  Upload Files
                  <input type="file" hidden multiple onChange={handleFileUpload} />
                </Button>
              </Grid>
            </Grid>
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {photos.length > 0 ? "Selected Photos: " : "" }
              </Typography>
              <Grid container spacing={1}>
                {photos.map((photo, index) => (
                  <Grid item key={index}>
                    <Chip
                      avatar={<Avatar src={URL.createObjectURL(photo)} />}
                      label={photo.name}
                      onDelete={() => handleRemovePhoto(index)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {files.length > 0 ? "Selected Files: " : ""}
              </Typography>
              <Grid container spacing={1}>
                {files.map((file, index) => (
                  <Grid item key={index}>
                    <Chip
                      label={file.name}
                      onDelete={() => handleRemoveFile(index)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </>
        ) : (
          <>
            <Autocomplete
              options={chatsdata}
              getOptionLabel={(option) => option.name}
              value={chatsdata.find(contact => contact.id === selectedContact) || null}
              onChange={(event, newValue) => setSelectedContact(newValue ? newValue.id : "")}
              renderInput={(params) => (
                <TextField {...params} label="Search Chat/Channel/Group" fullWidth />
              )}
            />
            <TextField
              label="Search Messages"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              fullWidth
              variant="outlined"
              sx={{ mb: 2, mt: 2 }}
            />
            <Button variant="contained" color="primary" onClick={handleFetchMessages}>
              Search
            </Button>
            <List sx={{ mt: 2 }}>
              {matchedMessages.map((message) => (
                <ListItem button key={message.id} onClick={() => handleSelectMessage(message)}>
                  <ListItemText primary={message.text} />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between", pr: 2 }}>
        <Button variant="outlined" onClick={handleBack}>
            Back
          </Button>
        <Button variant="contained" color="primary" onClick={handleNext}>
          Next
        </Button>
      </CardActions>
    </Card>
  );

  const renderStep2 = () => {
    

    return (
      <Card sx={{ mb: 4, borderRadius: 2, p: 2,  maxWidth: '80%',mx: 'auto' }}>
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6">Select Contacts</Typography>
            {/* <Button variant="outlined" color="secondary" onClick={}>
              Refresh Contacts
            </Button> */}
          </Grid>

          {/* Search Bar for Contacts */}
          <TextField
            label="Search Contacts"
            value={searchContactText}
            onChange={(e) => setSearchContactText(e.target.value)}
            fullWidth
            variant="outlined"
            sx={{ mb: 3 }}
          />

          <TableContainer component={Paper} sx={{ borderRadius: 2, maxHeight: 450 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell align="center">Select</TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredContacts.map((contact) => (
                  <TableRow key={contact.id}>
                    <TableCell align="center">
                      <Checkbox
                        checked={selectedContacts.some((c) => c.id === contact.id)}
                        onChange={() => handleSelectContact(contact)}
                      />
                    </TableCell>
                    <TableCell>{contact.id}</TableCell>
                    <TableCell>{contact.name}</TableCell>
                  </TableRow>
                ))}
                {filteredContacts.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No contacts found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
        <CardActions sx={{ justifyContent: "space-between", px: 2 }}>
          <Button variant="outlined" onClick={handleBack}>
            Back
          </Button>
          <Button variant="contained" color="primary" onClick={handleNext}>
            Next
          </Button>
        </CardActions>
      </Card>
    );
  };


  const renderStep4 = () => {
    
  
    
  
    return (
      <Card sx={{ mb: 4, borderRadius: 2, p: 2, maxWidth: '80%', mx: 'auto' }}>
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6">Select Message Type</Typography>
          </Grid>
  
          <RadioGroup value={messageType} onChange={handleMessageTypeChange}>
            <FormControlLabel value="instant" control={<Radio />} label="Instant Message" />
            <FormControlLabel value="schedule" control={<Radio />} label="Schedule Message" />
            <FormControlLabel value="postpone" control={<Radio />} label="Postponed Message" />
          </RadioGroup>
  
          
  
          
        </CardContent>
        <CardActions sx={{ justifyContent: "space-between", px: 2 }}>
          <Button variant="outlined" onClick={handleBack}>
            Back
          </Button>
          <Button variant="contained" color="primary" onClick={handleNext}>
            Next
          </Button>
        </CardActions>
      </Card>
    );
  };
  

  const renderStep3 = () => (
    <Card sx={{ mb: 4, borderRadius: 2, p: 2, maxWidth: '80%',mx:"auto" }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Select Sender Number
        </Typography>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Select</TableCell>
                <TableCell>Phone Number</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {senderNumbers.map((sender) => (
                <TableRow key={sender.id}>
                  <TableCell>
                    <Radio
                      checked={selectedSender === sender.id}
                      onChange={() => {setSelectedSender(sender.id);getChatsData(sender)}}
                    />
                  </TableCell>
                  <TableCell>{sender.phone_number}</TableCell>
                  <TableCell>{sender.status}</TableCell>
                </TableRow>
              ))}
              {senderNumbers.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No sender numbers available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', px: 2 }}>
        {/* <Button variant="outlined" onClick={handleBack}>
          Back
        </Button> */}
        <Button variant="contained" color="primary" onClick={handleNext}>
          Next
        </Button>
      </CardActions>
    </Card>
  );

  const renderStep5 = () => (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card sx={{ borderRadius: 2, p: 4,  maxWidth: '80%', mx: 'auto' }}>
        <CardContent>
          {/* Instant Message */}
          {messageType === "instant" ?
          <>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
            Send Message
          </Typography>
          <Button
            variant="contained"
            color="success"
            fullWidth
            sx={{ py: 1.5, fontSize: '1rem', borderRadius: 2 }}
            onClick={handleInstantSend}
          >
            Send Instantly
          </Button>
          </>  : ""
        }
  
          {/* Schedule Message */}
          {messageType == "schedule" 
          ? <>
          <Typography variant="h5" fontWeight={600} sx={{ mt: 4, mb: 2 }}>
            Schedule Message
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={schedule.start}
                onChange={(e) => setSchedule({ ...schedule, start: e.target.value })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="End Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={schedule.end}
                onChange={(e) => setSchedule({ ...schedule, end: e.target.value })}
              />
            </Grid>
          </Grid>
  
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <TextField
                label="Repeat Every"
                type="number"
                fullWidth
                InputProps={{ inputProps: { min: 1 } }}
                value={schedule.repeat.value}
                onChange={(e) => handleRepeatChange('value', e.target.value)}
              />
              
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Interval"
                select
                fullWidth
                value={schedule.repeat.unit}
                onChange={(e) => handleRepeatChange('unit', e.target.value)}
                selected={"Months"}
              >
                {['Seconds', 'Minutes', 'Hours', 'Days', 'Weeks', 'Months'].map((unit) => (
                  unit === "Months"  ? (<MenuItem key={"(Int) by "+unit} value={unit.toLowerCase()}>
                  {"(Int) by "+unit}
                </MenuItem>) : unit === "Weeks" ? <MenuItem key={"(Int) by "+unit} value={unit.toLowerCase()}>
                    {"(Int) by "+unit}
                  </MenuItem> : <MenuItem key={unit} value={unit.toLowerCase()}>
                    {unit}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
  
          {/* Time Picker */}
          <Grid container spacing={2} sx={{ mt: 2 }} > 
            <Grid item xs={2}>
              <TimePicker
                disabled={disableDayFilter}
                label="Select Time"
                value={schedule.timeSlot}
                onChange={handleTimeChange}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
              
              {disableDayFilter && (
                <FormHelperText>
                  Specific time applies only when interval is days, weeks, or months.
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth ref={inputRef} disabled={monthDateFilter}>
                
              <TextField
                disabled={monthDateFilter}
                label="Specfic Date"
                select
                
                value={schedule.monthdate}
                onChange={(e) => setSchedule({ ...schedule, monthdate: e.target.value })}
                
                fullWidth
              >
                
                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                  <MenuItem key={day} value={day}>
                    {day}
                  </MenuItem>
                ))}
              </TextField>
                  
                
                {monthDateFilter && (
                  <FormHelperText>
                    Date filter applies only when interval is months.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth disabled={disableDayFilter || !monthDateFilter}>
                <InputLabel>Days</InputLabel>
                <Select
                  multiple
                  value={schedule.dayFilter}
                  onChange={handleDayChange}
                  disabled={disableDayFilter || !monthDateFilter}
                  renderValue={(selected) => selected.join(', ')}
                >
                  
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                    <MenuItem key={day} value={day}>
                      <Checkbox checked={schedule.dayFilter.includes(day)} />
                      <ListItemText primary={day} />
                    </MenuItem>
                  ))}
                </Select>
                {disableDayFilter && (
                  <FormHelperText>
                    Day filter applies only when interval is days, weeks, or months.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
  
          {/* Schedule Button */}
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ py: 1.5, fontSize: '1rem', borderRadius: 2 }}
              onClick={handleScheduleSend}
            >
              Schedule Message
            </Button>
          </Box>
          </> : ""
        }
          

          {messageType === "postpone" 
          ?<>
          <Typography variant="h5" fontWeight={600} sx={{ mt: 4, mb: 2 }}>
            Postpond Message
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={10} >
            {/* <InputLabel>Select Dates</InputLabel> */}
            <DatePicker
            id="dp-multiple"
            containerStyle={{ width: "100%" }}
            multiple
            sort
            style={{
              width: "100%",
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 25,
              paddingBottom: 25
            }}
            format="YYYY-MM-DD"
            value={value} // This will now store formatted date strings
            onChange={handleDateChange}
            fullWidth
          />


            </Grid>
            <Grid item xs={2}>
            <TimePicker
                disabled={disableDayFilter}
                label="Select Time"
                value={schedule.timeSlot}
                onChange={handleTimeChange}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
          </Grid>
  
          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="warning"
              fullWidth
              sx={{ py: 1.5, fontSize: '1rem', borderRadius: 2 }}
              onClick={handlePostpondSend}
            >
              Postpond Message
            </Button>
          </Box></> : ""}
          
        </CardContent>
  
        <CardActions sx={{ justifyContent: 'space-between' }}>
          <Button variant="outlined" sx={{ borderRadius: 2 }} onClick={handleBack}>
            Back
          </Button>
        </CardActions>
      </Card>
    </LocalizationProvider>
  );
  

  

  return (
    <Container maxWidth="xxxl" sx={{ mt: 4, mb: 1 }}>
      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              sx={{
                "& .MuiStepLabel-label": { fontWeight: "bold" },
                "& .Mui-active .MuiStepLabel-label": { color: "primary.main" }
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && renderStep3()}
      {activeStep === 1 && renderStep1()}
      {activeStep === 2 && renderStep2()}
      {activeStep === 3 && renderStep4()}
      {activeStep === 4 && renderStep5()}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog open={openTemplateDialog} onClose={() => setOpenTemplateDialog(false)}>
        <DialogTitle>Add New Template</DialogTitle>
        <DialogContent>
          <TextField
            label="Template Text"
            value={newTemplateText}
            onChange={(e) => setNewTemplateText(e.target.value)}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTemplateDialog(false)}>Cancel</Button>
          <Button onClick={handleAddTemplate} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default MessageCreation;